module.exports = __webpack_public_path__ + "static/media/50019.d9803c71.png";